import { render, staticRenderFns } from "./FilterItemCategory.vue?vue&type=template&id=264c8c00&scoped=true&"
import script from "./FilterItemCategory.vue?vue&type=script&lang=js&"
export * from "./FilterItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemCategory.vue?vue&type=style&index=0&id=264c8c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c8c00",
  null
  
)

export default component.exports